import SolidButton from '@/components/Common/Button/SolidButton'
import { useTranslation } from 'react-i18next'

const ApplicationNone = () => {
  const { t } = useTranslation('common')
  return (
    <>
      <div className="flex items-center justify-center">
        <p className="text-sm font-semibold text-normal lg:text-lg">{t('cta.none.message')}</p>
      </div>
      <div className="w-full lg:max-w-[160px]">
        <SolidButton className="!h-10 !w-full lg:!h-11" disabled={true}>
          {t('cta.none.button')}
        </SolidButton>
      </div>
    </>
  )
}

export default ApplicationNone
